<template>
    <div class="header">
        <div class="logo" :class="isCollapsed?'logo-collapse-width':'logo-width'">
            {{ isCollapsed? "" : logoName }}
            <Icon @click="collapsedSider" :class="rotateIcon" :style="{margin: '0 20px'}" type="md-menu" size="24"></Icon>
        </div>
        <div class="userinfo">
            <Dropdown trigger="click">
                <span class="el-dropdown-link userinfo-inner">
                    {{adminUserName}}
                    <Icon type="ios-arrow-down"></Icon>
                    </span>
                <DropdownMenu slot="list">
                    <DropdownItem>我的消息</DropdownItem>
                    <DropdownItem @click.native="cpShow= {show: true}">修改密码</DropdownItem>
                    <DropdownItem @click.native="logout()">退出登录</DropdownItem>
                </DropdownMenu>
            </Dropdown>
            <ChangePassword :show.sync="cpShow"></ChangePassword>
        </div>
    </div>
</template>

<script>
import api from '@/api/index';
import ChangePassword from '@/components/user/ChangePassword';
import { title } from '@/config';
export default {
    components: {
        ChangePassword
    },
    data() {
        return {
            isCollapsed: false,
            logoName: title,
            adminUserName: localStorage.getItem('CMSUserName'),
            cpShow: {}
        };
    },
    computed: {
        rotateIcon() {
            return ['menu-icon', this.isCollapsed ? 'rotate-icon' : ''];
        }
    },
    methods: {
        // 退出登录
        logout() {
            this.$Modal.confirm({
                title: '提示',
                content: '确认退出吗?',
                onOk: () => {
                    api.common.logout();
                    localStorage.removeItem('loginToken');
                    this.$router.push('/');
                    window.location.reload();
                }
            });
        },
        collapsedSider() {
            this.isCollapsed = !this.isCollapsed;
            this.$emit('siderToggleCollapse');
        }
    }
};
</script>

<style scoped lang="scss">
.header {
    height: 60px;
    line-height: 60px;
    position: relative;
    z-index: 10;
    color: #fff;
    .logo {
        position: absolute;
        left: 0;
        font-size: 16px;
        padding: 0 20px;
        text-align: center;
        .menu-icon {
            transition: all .3s;
            position: absolute;
            right: -44px;
            height: 60px;
            line-height: 60px;
            cursor: pointer;
        }
        .rotate-icon{
            transform: rotate(-90deg);
        }
    }
    .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;
        .userinfo-inner {
            cursor: pointer;
            color:#fff;
            img {
                width: 40px;
                height: 40px;
                border-radius: 20px;
                margin: 10px 0px 10px 10px;
                float: right;
            }
        }
    }
    // sider未收缩时宽度
    .logo-width{ width:230px; }
    // sider收缩时宽度
    .logo-collapse-width{ width:78px }
}
</style>
